/**
 * @component PaperMetadataSkeleton
 * @description Loading skeleton for paper metadata that shows animated placeholders
 */
function PaperMetadataSkeleton() {
  return (
    <div className="flex items-center gap-2">
      <div className="space-y-2 animate-pulse">
        <div className="bg-bg-subtle h-4 w-10 rounded-xl" />
      </div>
      <span>·</span>
      <div className="space-y-2 animate-pulse">
        <div className="bg-bg-subtle h-4 w-20 rounded-xl" />
      </div>
      <span>·</span>
      <div className="space-y-2 animate-pulse">
        <div className="bg-bg-subtle h-4 w-16 rounded-xl" />
      </div>
      <span>·</span>
      <div className="space-y-2 animate-pulse">
        <div className="bg-bg-subtle h-4 w-24 rounded-xl" />
      </div>
    </div>
  );
}

export default PaperMetadataSkeleton;
